import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {Test} from '../../models/test';
import {Session} from "../../models/session";
import {Category} from "../../models/category";
import {SectionName} from "../../models/section";
import {Question, QuestionGroup} from "../../models/question";

export const getMockTests = async (client: AxiosInstance) =>
    responseHandler<{
        tests: Test[],
        testAttempts: Session[]
    }>(client.get('/tests?mode=mock'))

export const getPracticeTests = async (client: AxiosInstance, page?: number) =>
    responseHandler<{
        tests: Test[],
        testAttempts: Session[],
        stats: {
            [key in SectionName]: {
                testCount: number,
                attempts: number
            }
        }
    }>(client.get(`/tests?mode=practice&page=${page || 1}`))

export const getTestStats = async (client: AxiosInstance, page?: number) =>
    responseHandler<{
        [key in SectionName]: {
            attempts:number,
            total:number
        }
    }>(client.get(`/tests/stats`))

export const getTest = async (client: AxiosInstance, testId: string) =>
    responseHandler<Test>(client.get(`/tests/${testId}`))

export const getNextTest = async (client: AxiosInstance, section: SectionName) =>
    responseHandler<{
        test: Test,
        questions: (Question | QuestionGroup)[]
    }>(client.get(`/tests/next?section=${section}`))
